/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { S2WGame } from './S2WGame';
import {
    S2WGameFromJSON,
    S2WGameFromJSONTyped,
    S2WGameToJSON,
} from './S2WGame';
import type { RewardScheduleWithGame } from './RewardScheduleWithGame';
import {
    RewardScheduleWithGameFromJSON,
    RewardScheduleWithGameFromJSONTyped,
    RewardScheduleWithGameToJSON,
} from './RewardScheduleWithGame';

/**
 * 
 * @export
 * @interface RewardSchedulesWithGames
 */
export interface RewardSchedulesWithGames {
    /**
     * Every S2W game for the customer, ordered by name, including games with no current prize schedule
     * @type {Array<S2WGame>}
     * @memberof RewardSchedulesWithGames
     */
    games: Array<S2WGame>;
    /**
     * Every prize schedule that has not yet ended, grouped by S2W game then ordered by start date
     * @type {Array<RewardScheduleWithGame>}
     * @memberof RewardSchedulesWithGames
     */
    schedules: Array<RewardScheduleWithGame>;
}

/**
 * Check if a given object implements the RewardSchedulesWithGames interface.
 */
export function instanceOfRewardSchedulesWithGames(value: object): value is RewardSchedulesWithGames {
    if (!('games' in value) || value['games'] === undefined) return false;
    if (!('schedules' in value) || value['schedules'] === undefined) return false;
    return true;
}

export function RewardSchedulesWithGamesFromJSON(json: any): RewardSchedulesWithGames {
    return RewardSchedulesWithGamesFromJSONTyped(json, false);
}

export function RewardSchedulesWithGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardSchedulesWithGames {
    if (json == null) {
        return json;
    }
    return {
        
        'games': ((json['games'] as Array<any>).map(S2WGameFromJSON)),
        'schedules': ((json['schedules'] as Array<any>).map(RewardScheduleWithGameFromJSON)),
    };
}

export function RewardSchedulesWithGamesToJSON(value?: RewardSchedulesWithGames | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'games': ((value['games'] as Array<any>).map(S2WGameToJSON)),
        'schedules': ((value['schedules'] as Array<any>).map(RewardScheduleWithGameToJSON)),
    };
}

